import React from 'react';

function getLocalStorageOrDefault(key, defaultValue) {
  const stored = localStorage.getItem(key);
  if (!stored) {
    return defaultValue;
  }
  return JSON.parse(stored);
}

export default function useLocalStorage(key, defaultValue) {
  const [value, setValue] = React.useState(getLocalStorageOrDefault(key, defaultValue));

  const reFetch = () => {
    setValue(getLocalStorageOrDefault(key, defaultValue));
  };

  React.useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue, reFetch];
}
